import type { banque as Fr } from '../fr/banque';

/** « banque » in English — typed on the French: a missing sentence does not compile. */
export const banque: typeof Fr = {
  titre: 'Bank',
  sousTitre: 'The agency\'s account · separate from the cash register, and it must stay that way',
  versementRetrait: 'Deposit / withdrawal',
  fraisBancaires: 'Bank charges',
  totalBanque: 'Total in the bank',
  mouvements: 'Account movements',
  videTitre: 'No bank movements',
  videAction: 'Record a deposit',
  videTexte: 'Deposit at the bank whatever does not need to stay in the cash register. Each deposit creates two lines — money out of the cash register, money into the bank — so that nothing appears or disappears.',
  colonnes: { date: 'Date', libelle: 'Description', reference: 'Reference', montant: 'Amount', par: 'By' },
  note: 'A deposit shows on both sides: it leaves the cash register and enters the bank. The total of the two does not change — that is what lets you trace a discrepancy.',
  transfert: {
    libelleDepot: 'Bank deposit',
    libelleRetrait: 'Withdrawal for the cash register',
    depose: (m) => `${m} deposited at the bank — the cash register went down by the same amount.`,
    retire: (m) => `${m} withdrawn from the bank — the cash register went up by the same amount.`,
    impossible: 'Operation not possible',
    sens: 'Direction',
    versBanque: 'From the cash register to the bank',
    versCaisse: 'From the bank to the cash register',
    montant: (devise) => `Amount (${devise})`,
    reference: 'Reference',
    referenceAide: 'Deposit slip number, optional.',
    libelle: 'Description',
    deuxLignes: 'Two lines will be created',
    explication: (versBanque) => `Money out of ${versBanque ? 'the cash register' : 'the bank'} and money into ${versBanque ? 'the bank' : 'the cash register'}. Money can neither appear nor disappear.`,
  },
  frais: {
    libelleDefaut: 'Account maintenance fee',
    enregistres: (m) => `Bank charges recorded — ${m}.`,
    impossible: 'Could not be recorded',
    explication: 'They come out of the account, not the cash register: the cash register is not touched.',
  },
};
